<template>
  <div class="css-curriculumHead">
    <b-container align="center">
      <b-row>
        <b-col cols="12" align="center">
          <h2>내게 맞는 커리큘럼 찾기</h2>
          <p>코더스하이가 제공하는 교육과정을 소개합니다</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            variant="outline-light"
            :to="{
              name: 'curriculumshow',
              params: { id: 0 }
            }"
            pill
          >iOS 앱 디자인과 앱 개발과정</b-button>
        </b-col>
        <b-col>
          <b-button
            variant="outline-light"
            :to="{
              name: 'curriculumshow',
              params: { id: 1 }
            }"
            pill
          >코딩 배우기</b-button>
        </b-col>
        <b-col>
          <b-button
            variant="outline-light"
            :to="{
              name: 'curriculumshow',
              params: { id: 2 }
            }"
            pill
          >App 기획자/UX 디자인 과정</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.css-curriculumHead {
  background-color: #4c9bff;
  color: white;
}
</style>
